/**
 * Don't forget to change the id at the "businessName", "cnpj", "taxvat" and "peopleAmount"
 * to the id of the "Atendimento a Empresas" subject.
 * */
const contactValidator = props => {
    // Destructured props
    const {formValues} = props;

    // Actual form field validator
    const validateForm = props => {
        // Destructured props
        const {
            target,
            value
        } = props;

        let errors = {};

        // The regexes for the value to be validated from
        const emailRegex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
        const taxVatRegex = new RegExp("^\\d{3}\\.\\d{3}\\.\\d{3}\\-\\d{2}$");

        // Validates each individual field
        switch (target) {
            case "subject":
                if (!value) {
                    errors.subject = "Esse campo é obrigatório.";
                } else {
                    errors.subject = "";
                }

                break;
            case "name":
                if (!value) {
                    errors.name = "Esse campo é obrigatório.";
                } else if (value && value.length < 5) {
                    errors.name = "Seu nome deve ter no mínimo 5 caracteres.";
                } else {
                    errors.name = "";
                }

                break;
            case "email":
                if (!value) {
                    errors.email = "Esse campo é obrigatório.";
                } else if (value && !emailRegex.test(value)) {
                    errors.email = "Insira um endereço de email válido.";
                } else if (value.endsWith(".co")) {
                    errors.email = "Insira um endereço de email válido.";
                } else {
                    errors.email = "";
                }

                break;
            case "businessName":
                if (formValues.subject === "services-to-companies") {
                    if (!value) {
                        errors.businessName = "Esse campo é obrigatório.";
                    } else if (value && value.length < 5) {
                        errors.businessName = "Esse campo deve ter no mínimo 5 caracteres.";
                    } else {
                        errors.businessName = "";
                    }
                } else {
                    errors.businessName = "";
                }

                break;
            case "cnpj":
                if (formValues.subject === "services-to-companies") {
                    if (!value) {
                        errors.cnpj = "Esse campo é obrigatório.";
                    } else if (value && value.length < 18) {
                        errors.cnpj = "Insira um CNPJ válido.";
                    } else {
                        errors.cnpj = "";
                    }
                } else {
                    errors.cnpj = "";
                }

                break;
            case "ddd":
                if (!value) {
                    errors.ddd = "Esse campo é obrigatório.";
                } else {
                    errors.ddd = "";
                }

                break;
            case "phoneNumber":
                if (!value) {
                    errors.phoneNumber = "Esse campo é obrigatório.";
                } else {
                    errors.phoneNumber = "";
                }

                break;
            case "taxvat":
                if (formValues.subject !== "services-to-companies") {
                    if (!value) {
                        errors.taxvat = "Esse campo é obrigatório.";
                    } else if (value && !taxVatRegex.test(value)) {
                        errors.taxvat = "Insira um número de CPF válido.";
                    } else {
                        errors.taxvat = "";
                    }
                } else {
                    errors.taxvat = "";
                }

                break;
            case "peopleAmount":
                if (formValues.subject === "services-to-companies") {
                    if (!value) {
                        errors.peopleAmount = "Esse campo é obrigatório.";
                    } else {
                        errors.peopleAmount = "";
                    }
                } else {
                    errors.peopleAmount = "";
                }

                break;
            case "serviceTypes":
                if (formValues.subject === "services-to-companies") {
                    if (value.length === 0) {
                        errors.serviceTypes = "Esse campo é obrigatório.";
                    } else {
                        errors.serviceTypes = "";
                    }
                } else {
                    errors.serviceTypes = "";
                }

                break;
            case "message":
                if (!value) {
                    errors.message = "Esse campo é obrigatório.";
                } else {
                    errors.message = "";
                }

                break;
            default:
                return errors;
        }

        return errors;
    }

    // Method to perform a validation in all fields at once
    const validateAll = () => {
        let errors = {};

        // Iterates through each field validating them
        Object.keys(formValues).forEach(key => {
            errors = {
                ...errors,
                ...validateForm({
                    target: key,
                    value: formValues[key]
                })
            }
        })

        // Returns the errors object to be set into the errors state
        return errors;
    }

    return {
        validateForm,
        validateAll
    }
}

export default contactValidator;
